<template>
  <div
    class="job-agent-section flex justify-center w-full"
    :class="{
      'py-8 md:py-24': this.initialStep === 0,
      'py-0': this.initialStep > 0,
    }"
    :style="`background-color: ${
      this.initialStep === 0 ? '#f8f8f8' : 'transparent'
    };`"
  >
    <div class="content-wrapper relative">
      <div class="xing-shape-wrapper absolute">
        <img
          class="xing-shape"
          src="@/assets/images/xing-shape.png"
          v-show="initStep > 0"
        />
      </div>
      <div class="content-wrapper w-full">
        <JobAgentWidget :initial-step="initStep" @changeStep="changeStep" />
      </div>
    </div>
  </div>
</template>

<script>
import JobAgentWidget from "../JobAgentWidget.vue";
export default {
  name: "JobAgentSection",
  components: {
    JobAgentWidget,
  },
  props: ["initialStep"],
  data() {
    return {
      initStep: this.initialStep,
    };
  },
  watch: {
    initialStep(val) {
      this.initStep = val;
    },
  },
  methods: {
    changeStep(nextStep) {
      this.initStep = nextStep;
      this.$emit("changeStep", nextStep);
    },
  },
};
</script>

<style lang="postcss" scoped>
.xing-shape-wrapper {
  left: -30%;
  bottom: 25%;
  z-index: -1;
}

@media (max-width: 640px) {
  .xing-shape-wrapper {
    @apply hidden;
  }

  .content-wrapper {
    max-width: 100% !important;
  }
}
</style>
